import React, { useState } from 'react';
// @ts-ignore
import styles from './QuestionnaireList.module.scss';
import { useEffectAsync } from '../../helpers';
import QuestionnaireListItem, {
	QuestionnaireSchedule,
} from './QuestionnaireListItem';
import QuestionnairePlanningModal from '../../Modules/Questionnaire/Components/QuestionnairePlanning/QuestionnairePlanningModal';
import { PlannedQuestionnairesFilterValues } from '../../Modules/Questionnaire/Components/PlannedQuestionnaires/PlannedQuestionnairesFilter/PlannedQuestionnairesFilter';
import { useLazyQuestionnaireSchedulesQuery } from '../../graphql/graphql';
import Button from '../Button/Button';
import { Theme } from '../../Enums/Theme.enum';

interface Props {
	patientId?: string;
	showControls?: boolean;
	toggleRefreshData?: boolean;
	showPatientName?: boolean;
	filter?: PlannedQuestionnairesFilterValues;
}

const QuestionnaireList: React.FC<Props> = ({
	patientId,
	showControls = true,
	toggleRefreshData,
	showPatientName = false,
	filter,
}) => {
	const [getQuestionnaireSchedules] = useLazyQuestionnaireSchedulesQuery();
	const [questionnairesSchedules, setQuestionnairesSchedules] = useState<
		QuestionnaireSchedule[]
	>([]);
	const [planningOpened, setPlanningOpened] = useState(false);

	// @ts-ignore
	useEffectAsync(async () => {
		await loadData();
	}, [toggleRefreshData, filter]);

	// @ts-ignore
	const loadData = async () => {
		const tempQuestionnairesSchedules: any[] = [];

		const { questionnaireSchedules } = await getQuestionnaireSchedules({
			userId: filter?.patientId,
			questionnaireId: filter?.questionnaireId,
		}).unwrap();

		if (questionnaireSchedules?.data) {
			for (const questionnaireSchedule of questionnaireSchedules.data) {
				tempQuestionnairesSchedules.push({
					...questionnaireSchedule,
					questionnaireId: questionnaireSchedule?.questionnaire?.id,
					planedFrom: questionnaireSchedule?.dateFrom,
					planedTo: questionnaireSchedule?.dateTo,
					title: questionnaireSchedule?.questionnaire?.title,
					frequencyText: questionnaireSchedule?.frequencyText,
					byDoctor: questionnaireSchedule?.createdBy?.profile?.fullName,
					repeatHours: questionnaireSchedule?.repeatHours,
				});
			}
		}

		setQuestionnairesSchedules(
			tempQuestionnairesSchedules as QuestionnaireSchedule[],
		);
	};

	const handlePlanNewQuestionnaire = () => {
		setPlanningOpened(true);
	};

	const handleClosePlanning = async () => {
		setPlanningOpened(false);
		await loadData();
	};

	const handleUpdateItem = async () => {
		await loadData();
	};

	return (
		<div className={styles.wrapper}>
			{showControls && (
				<div className={styles.options}>
					<Button
						title={'base.scheduleNewMonitoring'}
						onClick={handlePlanNewQuestionnaire}
						theme={Theme.GREEN}
					/>
				</div>
			)}
			<div className={styles.list}>
				{questionnairesSchedules.map((item: QuestionnaireSchedule, index) => (
					<QuestionnaireListItem
						item={item}
						key={item.id}
						patientId={item?.user?.id}
						onUpdate={handleUpdateItem}
						showPatientName={showPatientName}
					/>
				))}
			</div>
			<QuestionnairePlanningModal
				opened={planningOpened}
				onClose={handleClosePlanning}
				patientId={patientId}
			/>
		</div>
	);
};

export default QuestionnaireList;
